import { NumberInputMaskPipe } from './number-input-mask.pipe';
import { DecimalPipe } from '@angular/common';
import { TranslateDistancePipe } from './translate-distance.pipe';
import { TranslateTimePipe } from './translate-time.pipe';
import { NgModule } from '@angular/core';

import { GetColorForDownloadsCounterPipe } from './get-color-for-downloads-counter.pipe';
import { ChangeMonthNumberToNamePipe } from './change-month-number-to-name.pipe';
import { ExtractTimePipe } from './extract-time.pipe';
import { OrderByPipe } from './order-by.pipe';
import { ExtractDateFromTachoPipe } from './extract-date-from-tacho.pipe';
import { ExtractDateFromXmlPipe } from './extract-date-from-xml.pipe';
import { ExtractDateFromPipe } from './extract-date-from.pipe';
import { ExtractDateToTachoPipe } from './extract-date-to-tacho.pipe';
import { ExtractDateToXmlPipe } from './extract-date-to-xml.pipe';
import { ExtractDateToPipe } from './extract-date-to.pipe';
import { ExtractDatePipe } from './extract-date.pipe';
import { GetProperIconForTypePipe } from './get-proper-icon-for-type.pipe';
import { DurationFormatPipe } from './duration-format.pipe';
import { PrintEmptyPipe } from './print-empty.pipe';
import { ReplacePipe } from './replace.pipe';

const pipes = [
  ChangeMonthNumberToNamePipe,
  ExtractTimePipe,
  ExtractDateFromTachoPipe,
  ExtractDateFromXmlPipe,
  ExtractDateFromPipe,
  ExtractDateToTachoPipe,
  ExtractDateToXmlPipe,
  ExtractDateToPipe,
  ExtractDatePipe,
  GetColorForDownloadsCounterPipe,
  GetProperIconForTypePipe,
  OrderByPipe,
  DurationFormatPipe,
  PrintEmptyPipe,
  TranslateTimePipe,
  TranslateDistancePipe,
  ReplacePipe,
  NumberInputMaskPipe,
];

@NgModule({
  declarations: [...pipes],
  exports: [...pipes],
  providers: [DecimalPipe],
})
export class PipesModule {
  static forRoot() {
    return {
      ngModule: PipesModule,
      providers: [],
    };
  }
}
